<div class="section light-bg sigma_portfolio-section">
    <div class="container">
        <div class="section-title text-left">
            <p class="subtitle">01 --- Portfolio</p>
            <h4 class="title">Awesome Case Studies</h4>
        </div>
        <!-- <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="sigma_portfolio-slider">
          
            <div ngxSlickItem class="portfolio-item" *ngFor="let item of casesblock">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="section">
                            <div class="section-title sm text-left">
                                <p class="subtitle">
                                    <span *ngFor="let cat of getCategories(item.category)">
                                        {{cat.title}} , 
                                    </span>
                                </p>
                                <h4 class="title">{{item.title}}</h4>
                            </div>
                            <p [innerHtml]="item.shorttext"></p>
                            <p> <span><b>Time Duration: </b> {{item.duration}}</span> <span
                                    class="d-inline-block ml-2" *ngFor="let client of getClient(item.client)"><b>Author:
                                    </b>{{client.name}}</span> </p>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <img [src]="item.image" [alt]="item.title">
                    </div>
                </div>
            </div>
            
        </ngx-slick-carousel> -->
        <!-- Custom Arrows Start -->
        <div class="sigma_arrows sigma_arrows-transparent sigma_arrows-dark mb-lg-30">
            <div class="sigma_round-arrow prev-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="125px" height="125px" viewBox="0 0 197 197" enable-background="new 0 0 197 197"
                    xml:space="preserve">
                    <circle class="sigma_round-arrow-stroke" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5">
                    </circle>
                    <circle class="sigma_round-arrow-circle" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5">
                    </circle>
                </svg>
                <i class="far fa-arrow-left slick-arrow slider-prev"></i>
            </div>
            <div class="sigma_round-arrow next-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    width="125px" height="125px" viewBox="0 0 197 197" enable-background="new 0 0 197 197"
                    xml:space="preserve">
                    <circle class="sigma_round-arrow-stroke" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5">
                    </circle>
                    <circle class="sigma_round-arrow-circle" stroke-linecap="round" cx="98.5" cy="98.6" r="97.5">
                    </circle>
                </svg>
                <i class="far fa-arrow-right slick-arrow slider-next"></i>
            </div>
        </div>
        <!-- Custom Arrows End -->
    </div>
</div>